<template>
  <div class="index">
    <div>
      <b-img id="main_img" :src="main_img" alt="Fluid image"></b-img>
    </div>
    <div class="body-imge py-4" style="padding-bottom: 12vh">
      <b-container fluid>
        <b-row>
          <b-col xl="4" md="6" sm="12">
            <b-card
              tag="article"
              style="background: #475161"
              class="card-box mb-2"
              text-variant="light"
              header-text-variant="light"
            >
            <b-card-text>
                <b-row>
                  <b-col cols="3" class="d-flex align-items-center">
                    <h2 style="color: #cbe86b">
                      {{ this.month }}/{{ this.day }}
                    </h2>
                  </b-col>
                  <b-col cols="9">
                    <b-row>
                      <b-col cols="6" class="d-flex align-items-center">
                        <div class="d-flex align-items-center">
                          <h5 class="mb-0">
                            <span
                            class="icon icon-temperature"
                            style="padding-right: 10px; font-size: x-large"
                          ></span>{{ weather.MinT }}&#176;~{{ weather.MaxT }}&#176;
                          </h5>
                        </div>
                      </b-col>
                      <b-col cols="6" class="d-flex align-items-center">
                        <div>
                          <h5 class="mb-0"><span
                            class="icon icon-Rainfall"
                            style="padding-right: 10px; font-size: x-large"
                          />{{ weather.PoP }}%</h5>
                        </div>
                      </b-col> 
                      <b-col cols="12">
                        <div class="alerGroup" >
                            <b-button v-for="(item, index ) in WarningList" :key="index" v-b-modal.modal-1 class="alert-btn" @click="NcdrChange(item)"><span class="icon-notification"></span>{{item.headline}}</b-button>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Modal -->
                <b-modal id="modal-First" title="氣象示警" hide-footer>
                  <template v-for="(item, index) in NcdrFirstWeather">
                    <div :key="index">
                      <h3>{{item.title}}:</h3>
                      <h5 v-if="item.effectTown">影響縣市:{{ item.effectTown }}</h5>
                      <h5 v-if="item.earthquakeValue != null && item.earthquakeValue !=''">地震等級:{{item.earthquakeValue}}</h5>
                      <h6 class="pb-2"><strong>描述:</strong></h6>
                      <p>{{item.description}}</p>
                      <hr>
                    </div>
                  </template>
                </b-modal>
                

                <b-modal id="modal-1" :title="NcdrWeatherContent.title" hide-footer>
                  <h5 v-if="NcdrWeatherContent.effectTown">影響縣市:{{ NcdrWeatherContent.effectTown }}</h5>
                  <h5 v-if="NcdrWeatherContent.earthquakeValue != null">地震等級:{{NcdrWeatherContent.earthquakeValue}}</h5>
                  <h6 class="pb-2"><strong>描述:</strong></h6>
                  <p>{{NcdrWeatherContent.description}}</p>
                </b-modal>
                

                <!-- <b-modal id="modal-bulletin" title="系統維修公告(2/7-2/8) 暫停服務" hide-footer>
                  <p>
                    因進行更新維護作業，本系統將於2月7日(五)晚間17:00 至 2月8日(六) 早上9:00 暫停服務。系統將於2月8日(六)早上9:00前恢復正常運作。造成不便敬請見諒。
                  </p>
                </b-modal>  -->

                <b-row class="justify-content-md-center" no-gutters>
                  <!-- <b-col class="bbbbb" md="6" sm="12">
                <b-button class="menu-btn" block @click="$router.push({ name: 'GIS'})"><span class="icon icon-map1" /> 農情圖資 <span class="icon-btnArrow" /></b-button>
              </b-col>
              <b-col class="bbbbb" md="6" sm="12">
                <b-button class="menu-btn" block ><span class="icon icon-profit-analysis" /> 產銷儀錶板 <span class="icon-btnArrow" /></b-button>
              </b-col> -->
                  <b-col v-if="weather.img == null" class="bbbbb" cols="12">
                    <b-skeleton-img></b-skeleton-img>
                  </b-col>
                  <b-col v-else class="bbbbb" cols="12">
                    <!-- <b-img
                      :src="weather.img"
                      fluid-grow
                      alt="Responsive image"
                    ></b-img> -->
                    <!-- https://www.youtube-nocookie.com/embed/A9NhpdZ5BDc -->
                    <iframe 
                      width="100%" height="300" 
                      :src="weather.video" 
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen>
                    </iframe>
                  </b-col>
                  <b-col style="margin-top: 1rem" class="bbbbb" md="6" sm="12">
                    <b-button class="menu-btn" @click="openVideo" block
                      >氣象資訊 <span class="icon-btnArrow"/></b-button>
                    <!-- <b-button class="menu-btn" block><span class="icon icon-map1" /> 氣象資訊 <span class="icon-btnArrow" /></b-button> -->
                  </b-col>
                </b-row>
              </b-card-text>
              <template #header>
                <b-container class="bv-example-row bv-example-row-flex-cols">
                  <b-row >
                  <b-col cols="auto" class="mr-auto"><h3 class="">嘉義縣</h3></b-col>
                  <b-col cols="auto"><b-button class="menu-btn" @click="openDescriptionVideo" block>平台使用介紹請點我 <span class="icon-btnArrow"/></b-button></b-col>
                  </b-row>
                </b-container>
              </template>
            </b-card>
          </b-col>

          <b-col xl="4" md="6" sm="12">
            <!-- <b-col xl="3" md="6" sm="12"> -->
            <b-card
              tag="article"
              class="card-box card-size mb-2"
              header-class="info-header"
              header-text-variant="light"
            >
              <b-card-text>
                <b-row style="text-align: center" v-if="ifwarningloading">
                  <b-col
                    ><b-spinner variant="success" label="Spinning"></b-spinner
                  ></b-col>
                </b-row>
                <b-row class="aaaaaa" v-else align-h="start" no-gutters>
                  <template v-for="(item, index) in warningarray">
                    <b-col
                      class="bbbbb"
                      md="6"
                      sm="12"
                      v-if="item == 0"
                      :key="index"
                    >
                      <b-button
                        block
                        class="warning-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0} })
                        "
                        ><span class="icon icon-rain" /> 霪雨警戒
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-if="item == 1"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="warning-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:1} })
                        "
                        ><span class="icon icon-sunny" /> 高溫警戒
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 2"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="warning-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:2} })
                        "
                        ><span class="icon icon-foehn" /> 焚風警戒
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 3"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="warning-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:3} })
                        "
                        ><span class="icon icon-rainy" /> 降水警戒
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 4"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="warning-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:4} })
                        "
                        ><span class="icon icon-typhoon" /> 颱風警戒
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 11"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="warning-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:11} })
                        "
                        ><span class="icon icon-typhoon" /> 寒害警戒
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 5"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="notice-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:5} })
                        "
                        ><span class="icon icon-high_tprt" /> 注意回溫
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 6"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="notice-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:6} })
                        "
                        ><span class="icon icon-lower_tprt" /> 注意降溫
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 7"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="notice-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:0} })
                        "
                        ><span class="icon icon-rain" /> 注意霪雨
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 8"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="notice-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:8} })
                        "
                        ><span class="icon icon-rain" /> 注意梅雨
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 9"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="notice-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 , anchor:9 } })
                        "
                        ><span class="icon icon-sunny" /> 注意高溫
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                    <b-col
                      class="bbbbb"
                      v-else-if="item == 10"
                      :key="index"
                      md="6"
                      sm="12"
                    >
                      <b-button
                        block
                        class="notice-btn"
                        @click="
                          $router.push({ name: 'GIS', params: { tab: 0 ,anchor:10} })
                        "
                        ><span class="icon icon-chilling" /> 注意寒害
                        <span class="icon-btnArrow"
                      /></b-button>
                    </b-col>
                  </template>
                </b-row>
              </b-card-text>
              <template #header>
                <h3><span class="icon icon-caution-sign" /> 農作物氣象預警</h3>
              </template>
            </b-card>
          </b-col>

          <!-- 蔬果漲跌新設計 -->
          <b-col cols="12" xl="4">
            <b-card
              tag="article"
              class="card-box card-size mb-2"
              header-class="info-header"
              header-text-variant="light"
            >
            <template #header>
                <h3><span class="icon icon-UpDown" /> {{cropDate}}蔬果漲跌勢</h3>
            </template>
              <b-card-text>
                  <template v-if="ifupdownloading">
                    <b-row style="text-align: center">
                      <b-col
                        ><b-spinner variant="success" label="Spinning"></b-spinner
                      ></b-col>
                    </b-row>
                  </template>
                  <template v-else>
                    <b-row cols="1" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2" >
                      <b-col>
                        <div class="priceRise">
                          <div class="cropGroupTitle"> <b-icon-arrow-up></b-icon-arrow-up>漲勢作物(元/公斤)</div>
                          <v-select
                            style="min-width:fit-content;"
                            v-model="trade.upSelected"
                            :options="trade.upoptions"
                          ></v-select>
                          <div class="cropGroup scrollStyle"> 
                          <template v-for="(item, index) in trade.uplist">
                            <a :key="index" href="javascript:void(0);" @click="gotochart(item)">
                              <div class="cropGroupList">
                                  <div class="cropGroupItem" style="color: black;">{{ item.CROP }}</div>
                                  <div class="cropGroupPrice">{{item.AVG}}</div>
                              </div>
                            </a>
                          </template>
                        </div>
                        </div>
                      </b-col>
                      <!-- v-if="trade.downlist.length > 0" -->
                      <b-col class="pt-4 pt-sm-0 pt-md-0 pt-lg-0 pt-xl-0" >
                          <div class="priceDown">
                          <div class="cropGroupTitle"><b-icon-arrow-down></b-icon-arrow-down>跌勢作物(元/公斤)</div>
                          <v-select
                            style="min-width:fit-content;"
                            v-model="trade.downSelected"
                            :options="trade.downoptions"
                          ></v-select>
                          <div class="cropGroup scrollStyle priceRise">
                            <template v-for="(item, index) in trade.downlist">
                              <a :key="index" href="javascript:void(0);" @click="gotochart(item)">
                                <div class="cropGroupList">
                                  <div class="cropGroupItem" style="color: black;">{{ item.CROP }}</div>
                                  <!-- <div class="cropGroupPrice">{{parseFloat(item.WA).toFixed(1)}}</div> -->
                                  <div class="cropGroupPrice">{{item.AVG}}</div>
                                </div>
                              </a>
                            </template>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col style="margin: 5px 5px 5px 5px">
                        <span>{{ warningtext }}</span>
                        <br />
                        <span>{{ warningtext2 }}</span>
                      </b-col>
                    </b-row>  
                  </template>
                </b-card-text>
            </b-card>
          </b-col>
         
           <!--<b-card
            tag="article"
            class="card-box card-size mb-2"
            header-class="info-header"
            header-text-variant="light"
            >
            <b-card-text>
                <div style="text-align: center;" v-if="ifpestnoticeloading">
                    <b-col><b-spinner variant="success" label="Spinning"></b-spinner></b-col>
                </div>
                <div v-else>
                    <b-row>
                        <b-col cols="auto">
                            <template v-for="(item, index) in pestnotice.country">
                                <b-badge pill class="badge-style" :key="index">{{item}}</b-badge>
                            </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                        <div id="text-box">{{pestnotice.content}}</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                        <b-button variant="outline-dark" style="width: inherit;" block @click="showpestnotice">詳情</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-card-text>
            <template #header>
              <h3><span class="icon icon-bug" /> 植物病蟲害預警</h3>
            </template>
          </b-card>-->
        
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      weather: {
        MaxT: null,
        MinT: null,
        Wx: null,
        PoP: null,
        img: null,
        video: null,
        url: null,
      },
      NcdrType:["地震","颱風","海嘯","降雨","雷雨","低溫","強風","濃霧","高溫","火山"],
      NcdrList:[],
      WarningList:[],
      NcdrTypeList1:["強風","颱風","降雨","低溫","高溫","濃霧"],
      NcdrTypeList2:["雷雨"],
      NcdrTypeList3:["地震"],
      NcdrWeatherContent:{
        title:null,
        headline:null,
        description:null,
        senderName:null,
        effective:null,
        expires:null,
        earthquakeValue:null,
        effectTown:"",
      },
      NcdrFirstModal: true,
      NcdrWeatherLinks:[],
      NcdrFirstWeather:[],
      cropDate:null,
      pestnotice: {
        country: [],
        content: null,
      },
      warningtext:
        "漲跌勢判斷以RSV>80為漲勢、<20為跌勢；RSV=((加權平均-最近9日最低均價)/(最近9天最高均價-最近9天最低價))*100",
      warningtext2: "*RSV指未成熟隨機值",
      warningarray: [],
      warningdispalylist: [
        {
          key: "霪雨",
          value: 0,
        },
        {
          key: "高溫",
          value: 1,
        },
        {
          key: "焚風",
          value: 2,
        },
        // {
        //   key: "降水",
        //   value: 3,
        // },
        {
          key: "颱風",
          value: 4,
        },
        {
          key: "寒害",
          value: 11,
        },
        {
          key: "注意回溫",
          value: 5,
        },
        {
          key: "注意降溫",
          value: 6,
        },
        {
          key: "注意霪雨",
          value: 7,
        },
        {
          key: "注意梅雨",
          value: 8,
        },
        {
          key: "注意高溫",
          value: 9,
        },
        {
          key: "注意寒害",
          value: 10,
        },
      ],
      trade: {
        upSelected:{label: "請選擇", code: "請選擇", disabled: false },
        upoptions:[],
        uplist: [],
        originUplist:[],
        downSelected:{label: "請選擇", code: "請選擇", disabled: false },
        downoptions:[],
        downlist: [],
        originDownlist:[],
      },
      counter: 0,
      month: null,
      day: null,
      hour: "day",
      playlist:"PL9GjONJu_nMKBwF1g5Uu67qqMiyvwJD94",
      ifwarningloading: true,
      ifpestnoticeloading: true,
      ifupdownloading: true,
      main_img: require("../assets/banner_img.jpg"),
      text: "\r\r臺東地區鳳梨釋迦正值營養生長至開花期（夏季修剪期），經行政院農業委員會臺東區農業改良場（以下簡稱臺東場）監測發現卑南鄉鳳梨釋迦果園內有粉介殼蟲正處於若蟲期，且密度有上升之趨勢，臺東場籲請農友加強巡視果園，注意粉介殼蟲發生現況，於發生初期採行防治措施以降低害蟲密度，減少損失。臺東場指出，粉介殼蟲在鳳梨釋迦強剪後多藏匿於樹幹縫隙或樹幹基部，於萌芽後移動至枝條、嫩梢取食繁殖，並逐步擴散至其他部位。結果期則移至果柄、果蒂，甚至果實上取食為害。此外，其分泌之蜜露會吸引螞蟻取食，並誘發煤煙病影響果實外觀，降低商品價值，亦為影響果品外銷的重要因子。",
      apiGetWeather: (data) =>
        this.userRequest.post("API/Default/GetWeather", data),
      apiPestNoticeList: (data) =>
        this.userRequest.post("/API/Default/PestNoticeList", data),
      apiGetWarninginfo: (data) =>
        this.userRequest.post("API/Default/getScourge", data),
        // this.userRequest.post("API/Default/getScourgeWith3rd", data),
      apiGetMainTradeUP: () =>
        this.userRequest.get("/API/Default/GetMainTradeUP"),
      apiGetMainTradeDOWN: () =>
        this.userRequest.get("API/Default/GetMainTradeDOWN"),
      apiRiceBlastExcelUpload: (data) =>
        this.userRequest.post("API/Default/RiceBlastExcelUpload", data),
      apiGetWebsiteSetting: (data) =>
        this.userRequest.post("API/Default/GetWebsiteSetting", data),
      apiNcdr: (data) =>
        this.userRequest.post("/API/Default/NCDR_API",data),
      apiNcdrCapstorage : (data) =>
        this.useNCDR.get(data,),
    };
  },
  watch:{
    "trade.upSelected"(val){
      //console.log(val)
      if(val != null && val.label != "請選擇"){
        this.trade.uplist = this.trade.originUplist.filter(item => item.CROP.includes(val.label))
      }
      else{
        this.trade.uplist = this.trade.originUplist;
      }
    },
    "trade.downSelected"(val){
      if(val != null && val.label != "請選擇"){
        this.trade.downlist = this.trade.originDownlist.filter(item => item.CROP.includes(val.label))
      }
      else{
        this.trade.downlist = this.trade.originDownlist;
      }
    }
  },
  created() {
    
    this.FunctionToken(this.getcontent,{WS_MEMO:"youtube"});
    this.getMainTradeUP();
    this.getMainTradeDOWN();
    this.FunctionToken(this.getWeather, {});
    this.FunctionToken(this.getPestNoticeList, {});
    this.FunctionToken(this.getWarningData, {});
    this.FunctionToken(this.GetNCDR_CAP, {TYPE:"GETCAP"});
  },
  mounted() {
    //this.$bvModal.show('modal-bulletin');
    var d = new Date();
    this.month = d.getMonth() + 1;
    this.day = d.getDate();
    let hours = d.getHours();
    if (hours >= 18) this.hour = "night";
  },
  methods: {
    initNcdrWeatherContent(){
      this.NcdrWeatherContent.title = null;
      this.NcdrWeatherContent.headline = null;
      this.NcdrWeatherContent.description = null;
      this.NcdrWeatherContent.senderName = null;
      this.NcdrWeatherContent.effective = null;
      this.NcdrWeatherContent.expires = null;
      this.NcdrWeatherContent.earthquakeValue = null;
      this.NcdrWeatherContent.effectTown = "";
    },
    GetNCDR_CAP(data){
      this.apiNcdr(data)
        .then((res)=>{
          this.NcdrList =[];
          console.log("GetNCDR_CAP",res)
          let now = new Date();
          let nowDate = now.getFullYear()+"-"+String(now.getMonth()+1).padStart(2, '0')+"-"+String(now.getDate()).padStart(2, '0');
          //console.log(nowDate)
          let json = JSON.parse(res.data);
          if(json.Status){
            let jsondata = JSON.parse(json.Data);
            //console.log("GetNCDR_CAP jsondata",jsondata)
            let temp = jsondata.entry.sort((a,b) => new Date(b.updated) - new Date(a.updated));
            //let temp2 = [];
            console.log("GetNCDR_CAP temp",temp.filter((item) => this.NcdrType.includes(item.title)))
            temp.map((item) =>{
              if(item.updated.includes(nowDate) && this.NcdrType.includes(item.title) ){
                let index = this.NcdrList.findIndex(x => x.title == item.title);
                if(index == -1 ){
                  this.NcdrList.push(item)
                  if(item.title != "雷雨"){
                      setTimeout(() => {
                      this.FunctionToken(this.NcdrHeadline,{TYPE:"GetHeadline",link:item.link["@href"]})
                    }, 500);
                  }
                  else{
                    item["headline"] = item.title;
                    this.WarningList.push(item)
                    this.NcdrWeatherLinks.push(item.link["@href"])
                  }
                  //this.NcdrList.push(item)
                }
                
              }
            })
            console.log("this.NcdrWeatherLinks",this.NcdrWeatherLinks)
            setTimeout(()=>{
              if(this.NcdrWeatherLinks > 0){
                this.FunctionToken(this.NcdrFirst,{TYPE:"GetFirstWeathers",links:this.NcdrWeatherLinks})
              }
              else{
                setTimeout(()=>{
                  if(this.NcdrFirstWeather.length == 0 && this.NcdrWeatherLinks.length > 0){
                    this.FunctionToken(this.NcdrFirst,{TYPE:"GetFirstWeathers",links:this.NcdrWeatherLinks})
                  }
                },1000)
              }
            },1500)
            
            
            //console.log("item",this.NcdrList)
          }
          // console.log("GetNCDR_CAP",this.NcdrList)
      })
    },
    NcdrHeadline(data){
      this.apiNcdr(data)
        .then((res)=>{
          let json = JSON.parse(res.data);
          let xmlString = json.Data
          // 解析 XML 字串
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(xmlString, "application/xml");
          let now = new Date();
          // 獲取所有 <areaDesc> 元素
          const headlineElements = xmlDoc.getElementsByTagName("headline");
          // console.log("headlineElements",headlineElements[0].textContent)
          const eventElements = xmlDoc.getElementsByTagName("event");
          const expiresElements = xmlDoc.getElementsByTagName("expires");
          let dateTemp = new Date(expiresElements[0].textContent);
          console.log("eventElements",expiresElements[0].textContent,dateTemp , dateTemp > now)
          let index = this.NcdrList.findIndex(x => x.title == eventElements[0].textContent);
          if(index != -1 && dateTemp > now){
            this.NcdrList[index]["headline"] = headlineElements[0].textContent;
            this.WarningList.push(this.NcdrList[index])
            this.NcdrWeatherLinks.push(this.NcdrList[index].link["@href"])
          }          
        })
    },
    NcdrChange(item){
      this.initNcdrWeatherContent();
      this.FunctionToken(this.Ncdrdetail,{TYPE:"GetHeadline",link:item.link["@href"]})
    },
    Ncdrdetail(data){
      this.apiNcdr(data)
        .then((res) =>{
          let json = JSON.parse(res.data);
          //console.log("NcdrChange",json)
          let xmlString = json.Data
          // 解析 XML 字串
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(xmlString, "application/xml");
          const eventElements = xmlDoc.getElementsByTagName("event");
          let index = this.WarningList.findIndex(x => x.title == eventElements[0].textContent);
          if(index != -1){
            this.NcdrWeatherContent.title = this.WarningList[index].headline;
            this.NcdrWeatherContent.description = this.WarningList[index].summary["#text"];
            //抓取影響鄉鎮資料-不同類型抓取方式不同
            if(this.NcdrTypeList1.includes(this.WarningList[index].title)){
              const areaDescElements = xmlDoc.getElementsByTagName("areaDesc");
              for(let i = 0; i < areaDescElements.length -1 ; i++){
                if(areaDescElements[i].textContent.includes("嘉義縣")){
                  if(this.NcdrWeatherContent.effectTown != "" && i != areaDescElements.length -1) this.NcdrWeatherContent.effectTown += "、";
                  this.NcdrWeatherContent.effectTown += areaDescElements[i].textContent;
                }
              }
            }
            else if(this.NcdrTypeList2.includes(this.WarningList[index].title)){
              const parameterElements = xmlDoc.getElementsByTagName("parameter");
              for(let j = 0; j < parameterElements.length - 1; j++){
                if(parameterElements[j].textContent.includes("townships")){
                  const paramDoc = parser.parseFromString(parameterElements[j].outerHTML, "application/xml");
                  const valueElements = paramDoc.getElementsByTagName("value");
                  this.NcdrWeatherContent.effectTown = valueElements[0].textContent.replace(" ","、");
                  console.log("valueElements",valueElements[0].textContent,valueElements[0].textContent.replace(" ","、"))
                }
              }
            }
            else if(this.NcdrTypeList3.includes(this.WarningList[index].title)){
              const parameterElements = xmlDoc.getElementsByTagName("parameter");
              for(let j = 0; j < parameterElements.length - 1; j++){
                  if(parameterElements[j].textContent.includes("級;\"嘉義縣")){
                    const paramDoc = parser.parseFromString(parameterElements[j].outerHTML, "application/xml");
                    const valueElements = paramDoc.getElementsByTagName("value");
                    let temp = valueElements[0].textContent.split(";\"");
                    let earthquakeValue = temp[0];
                    let earthquakeTown = temp[1].split("\";")[0];
                    console.log("valueElements",earthquakeValue,earthquakeTown)
                    this.NcdrWeatherContent.earthquakeValue = earthquakeValue;
                    this.NcdrWeatherContent.effectTown = earthquakeTown;
                  }
              }
            }
          }
          
          
        })
    },
    NcdrTest(){
      let uri = "Capstorage/CWA/2024/thunderstorm/cwa.gov.tw_thunderstorm_20241009174200_000.cap"
      //let uri = 
      this.apiNcdrCapstorage(uri)
        .then((res)=>{
          console.log("NcdrChange",res)
          
          // let xmlString = res.data
          // // 解析 XML 字串
          // const parser = new DOMParser();
          // const xmlDoc = parser.parseFromString(xmlString, "application/xml");
          
          //抓取雷雨鄉鎮資料
          // const parameterElements = xmlDoc.getElementsByTagName("parameter");
          // for(let j = 0; j < parameterElements.length - 1; j++){
          //   if(parameterElements[j].textContent.includes("townships")){
          //     const paramDoc = parser.parseFromString(parameterElements[j].outerHTML, "application/xml");
          //     const valueElements = paramDoc.getElementsByTagName("value");
          //     this.NcdrWeatherContent.effectTown = valueElements[0].textContent.replace(" ","、");
          //     console.log("valueElements",valueElements[0].textContent,valueElements[0].textContent.replace(" ","、"))
          //   }
          // }
          //抓取地震資料
          // const parameterElements = xmlDoc.getElementsByTagName("parameter");
          
          // //console.log("parameterElements",parameterElements)
          // for(let j = 0; j < parameterElements.length - 1; j++){
          //     if(parameterElements[j].textContent.includes("級;\"嘉義縣")){
          //       const paramDoc = parser.parseFromString(parameterElements[j].outerHTML, "application/xml");
          //       const valueElements = paramDoc.getElementsByTagName("value");
          //       let temp = valueElements[0].textContent.split(";\"");
          //       let earthquakeValue = temp[0];
          //       let earthquakeTown = temp[1].split("\";")[0];
          //       console.log("valueElements",earthquakeValue,earthquakeTown)
          //       this.NcdrWeatherContent.earthquakeValue = earthquakeValue;
          //       this.NcdrWeatherContent.effectTown = earthquakeTown;
          //     }
          // }
          
          
          //this.$bvModal.show('modal-1')
        })
    },
    NcdrFirst(data){
      this.apiNcdr(data)
        .then((res) =>{
          
          let json = JSON.parse(res.data);
          
          if(json.Status){
            let jsondata = JSON.parse(json.Data);
            console.log("NcdrFirst",jsondata)
            jsondata.result.forEach((item) =>{
              let xmlString = item
              // 解析 XML 字串
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(xmlString, "application/xml");
              const eventElements = xmlDoc.getElementsByTagName("event");
              let index = this.WarningList.findIndex(x => x.title == eventElements[0].textContent);
              if(index != -1){
                let effectTown ="",
                    earthquakeValue ="";
                
                //抓取影響鄉鎮資料-不同類型抓取方式不同
                if(this.NcdrTypeList1.includes(this.WarningList[index].title)){
                  const areaDescElements = xmlDoc.getElementsByTagName("areaDesc");
                  for(let i = 0; i < areaDescElements.length -1 ; i++){
                    if(areaDescElements[i].textContent.includes("嘉義縣")){
                      if(effectTown != "" && i != areaDescElements.length -1) effectTown += "、";
                      effectTown += areaDescElements[i].textContent;
                    }
                  }
                }
                else if(this.NcdrTypeList2.includes(this.WarningList[index].title)){
                  const parameterElements = xmlDoc.getElementsByTagName("parameter");
                  for(let j = 0; j < parameterElements.length - 1; j++){
                    if(parameterElements[j].textContent.includes("townships")){
                      const paramDoc = parser.parseFromString(parameterElements[j].outerHTML, "application/xml");
                      const valueElements = paramDoc.getElementsByTagName("value");
                      effectTown = valueElements[0].textContent.replace(" ","、");
                      //console.log("valueElements",valueElements[0].textContent,valueElements[0].textContent.replace(" ","、"))
                    }
                  }
                }
                else if(this.NcdrTypeList3.includes(this.WarningList[index].title)){
                  const parameterElements = xmlDoc.getElementsByTagName("parameter");
                  for(let j = 0; j < parameterElements.length - 1; j++){
                      if(parameterElements[j].textContent.includes("級;\"嘉義縣")){
                        const paramDoc = parser.parseFromString(parameterElements[j].outerHTML, "application/xml");
                        const valueElements = paramDoc.getElementsByTagName("value");
                        let temp = valueElements[0].textContent.split(";\"");
                        let earthquakeValueTemp = temp[0];
                        let earthquakeTownTemp = temp[1].split("\";")[0];
                        console.log("valueElements",earthquakeValueTemp,earthquakeTownTemp)
                        earthquakeValue = earthquakeValueTemp;
                        effectTown = earthquakeTownTemp;
                      }
                  }
                }
                let ojb = {
                  title : this.WarningList[index].headline,
                  description : this.WarningList[index].summary["#text"],
                  effectTown : effectTown,
                  earthquakeValue : earthquakeValue,
                }
                this.NcdrFirstWeather.push(ojb)
              }
              
            })
            console.log("this.NcdrFirstWeather",this.NcdrFirstWeather)
            setTimeout(()=>{
              this.$bvModal.show('modal-First')
            },1000)
          }
        })
    },
    getWeather(data) {
      this.apiGetWeather(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.weather.MaxT = jsonData.MaxT;
            this.weather.MinT = jsonData.MinT;
            this.weather.Wx = this.padLeft(jsonData.Wx, 2);
            this.weather.PoP = jsonData.PoP;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getMainTradeUP() {
      this.apiGetMainTradeUP()
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
            //console.log(["apiGetMainTradeUP",jsonData])
          let date = jsonData[0].DATE.split("T");
          let getdate = date[0].split("-");
          this.cropDate = getdate[1].toString() + "/" + getdate[2].toString();
          //console.log("cropDate",this.cropDate);
          if (json.Status) {
            
            this.trade.uplist = jsonData;
            this.trade.originUplist = jsonData;
            jsonData.forEach( (x) =>{
              let obj = {
                    label: x.CROP,
                    code: x.CROP_CODE,
                    disabled: true,
              };
              this.trade.upoptions.push(obj);
            })
            this.trade.upoptions.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            })
            this.counter++;
            this.checkCount();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getMainTradeDOWN() {
      this.apiGetMainTradeDOWN()
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.trade.downlist = jsonData;
            this.trade.originDownlist = jsonData;
            jsonData.forEach((x) =>{
              let obj={
                label: x.CROP,
                code: x.CROP_CODE,
                disabled: true,
              }
              this.trade.downoptions.push(obj)
            })
            this.trade.downoptions.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            })
            this.counter++;
            this.checkCount();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getPestNoticeList(data) {
      this.apiPestNoticeList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.pestnotice.country = jsonData[0].PUBLISH.split("  ,");
            this.pestnotice.content = jsonData[0].CONTENTS;
            this.ifpestnoticeloading = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getWarningData(data) {
      this.apiGetWarninginfo(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            this.warningarray = [];
            jsonData.forEach((element) => {
              // let subindex = this.warningdispalylist.findIndex(
              //   (x) => x.key == element.DISASTER
              // );
              let sublist = this.warningdispalylist.filter(
                (it) => it.key == element.DISASTER
              );
              let subindex = sublist.length ? sublist[0].value : -1;

              if (this.warningarray.indexOf(subindex) == -1) {
                this.warningarray.push(subindex);
              }
            });
            //console.log("warningarray",this.warningarray)
            this.ifwarningloading = false;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //↓原天氣預警抓取"https://data.coa.gov.tw/Service/OpenData/Agriculturalcoa_videoRss.aspx"
    // getcontent() {
    //   this.axios
    //     .get(
    //       "https://data.moa.gov.tw/Service/OpenData/Agriculturalcoa_videoRss.aspx?&UnitId=F35"
    //     )
    //     .then((response) => {
    //       let item = response.data[0];
    //       this.weather.img = item.picimg1;
    //       this.weather.video = item.link;
    //     });
    // },
    //改寫
    getcontent(data) {
      this.apiGetWebsiteSetting(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if(json.Status){
            let jsonData = JSON.parse(json.Data);
            let playlistId , apikey;
            jsonData.forEach((item) =>{
              if(item.WS_MEMO.includes("playlistID")){
                playlistId = item.WS_VALUE;
              }
              if(item.WS_MEMO.includes("api key")){
                apikey = item.WS_VALUE;
              }
            })
            console.log("getcontent",playlistId,apikey)
            const apiurl = "https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=2&playlistId="+playlistId+"&key="+apikey;
            this.axios
            .get(
              apiurl
            )
            .then((response) => {
              let item = response.data;
              console.log("getcontent response",item);
              for(var data in item.items){
                let title = item.items[data].snippet.title;
                if(title !="Private video"){
                  let videoid = item.items[data].snippet.resourceId.videoId;
                  let videoimg = item.items[data].snippet.thumbnails.high.url;
                  //console.log("videoimg",videoimg);
                  //this.weather.video = "https://www.youtube.com/watch?v="+videoid;
                  this.weather.url = "https://www.youtube.com/watch?v="+videoid+"&list="+playlistId;
                  this.weather.video = "https://www.youtube.com/embed/"+videoid+"?rel=0&autoplay=1&mute=1&loop=1&playlist="+videoid+"&amp;showinfo=0";
                  this.weather.img = videoimg;
                  break;
                }
              }
              
              
              //console.log("weather.video",this.weather.video);
              // let item = response.data[0];
              // this.weather.img = item.picimg1;
              // this.weather.video = item.link;
            });
          }
        })
    },
    //新天氣預警抓取(透過API)
    openVideo() {
      //window.open(this.weather.video, "_blank");//原資料原失效，改下方直接抓網址，如找回資料原要改回
      //this.weather.video ="https://www.youtube.com/watch?v=A9NhpdZ5BDc&list=PL9GjONJu_nMKBwF1g5Uu67qqMiyvwJD94&index=1"
      window.open(this.weather.url, "_blank");
    },
    openDescriptionVideo() {
      window.open('https://www.youtube.com/watch?v=uS11DQPwfBE', "_blank");
    },
    checkCount() {
      if (this.counter == 2) {
        this.ifupdownloading = false;
      }
    },
    gotochart(value) {
      sessionStorage.setItem("Crop", value.CROP_CODE);
      this.$router.push({
        path: "normaldashboard/crop",
        // query: { Crop: value.V_NAME },
      });
    },
    // onExelUpload(e) {
    //   this.formData = new FormData();
    //   this.formData.append("file", e.target.files[0]);
    //   this.FunctionToken(this.RiceBlastExcelUpload, {});
    // },
    padLeft(str, lenght) {
      str = str.toString();
      if (str.length >= lenght) return str;
      else return this.padLeft("0" + str, lenght);
    },
    showpestnotice() {
      this.$router.push({ name: "GIS", params: { tab: 3 } });
    },
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body-imge {
  background-image: url("../assets/img_bg.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: bottom;
  background-size: contain;
  background-color: #fff6eb;
}
#main_img {
  width: 100%;
}
#main-background {
  height: 55vh;
  background: url("https://img.freepik.com/free-photo/hand-painted-watercolor-background-with-sky-clouds-shape_24972-1095.jpg?size=626&ext=jpg");
}
#div-content {
  margin-right: 10vh;
  margin-left: 10vh;
}

#text-box {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  font-size: medium;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  margin: 5px 5px 5px 5px;
}
.info-header {
  background: #475161;
  padding: 10px 10px 10px 20px;
}
.menu-btn {
  font-weight: bold;
  background: #cbe86b;
  color: #475161;
}
.menu-btn:hover {
  background: #72be72 !important;
}
.rise-btn {
  color: red;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
  width: -webkit-fill-available;
}
.drop-btn {
  color: green;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
  width: -webkit-fill-available;
}
#rise-box {
  background: red;
  border-color: red;
  color: white;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px;
}
#drop-box {
  background: green;
  border-color: green;
  color: white;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px;
}
.warning-btn {
  /* font-size: smaller; */
  background: #ff614c;
  border-color: #ff614c;
  color: white;
}
.warning-btn:hover {
  background: #db3c30 !important;
  border-color: #db3c30 !important;
}
.notice-btn {
  /* font-size: smaller; */
  background: #f5b847;
  border-color: #f5b847;
  color: white;
}
.notice-btn:hover {
  background: #d98e3f !important;
  border-color: #d98e3f !important;
}
.badge-style {
  background: #475161;
  width: fit-content;
  padding: 5px 5px 5px 5px;
  margin: 5px 5px 5px 5px;
}
</style>

<style lang="scss">
.aaaaaa {
  padding: 0.25rem;
  //  border: 1px solid #ccc;
  .bbbbb {
    padding: 0.25rem !important;
  }
}
</style>
